import { trace, context, SpanStatusCode } from "@opentelemetry/api";
class TracingService {
  getTracer() {
    return trace.getTracer("admin-panel");
  }
  setSpanOnContext(span) {
    const ctx = parent ? trace.setSpan(context.active(), span) : void 0;
    return ctx;
  }
  endSpanOk(span) {
    if (span) {
      span.setStatus({ code: SpanStatusCode.OK });
      span.end();
    }
  }
  endSpanFailed(span, message) {
    if (span) {
      span.setStatus({ code: SpanStatusCode.ERROR, message });
      span.addEvent(message);
      span.end();
    }
  }
}
export {
  TracingService
};
//# sourceMappingURL=TracingService.js.map
